import { render, staticRenderFns } from "./PackingPositionLightOff.vue?vue&type=template&id=74062990"
import script from "./PackingPositionLightOff.vue?vue&type=script&lang=js"
export * from "./PackingPositionLightOff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports